export const smediasActions = {

};